import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.FormsStreams';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class FormsStreams extends RpcClass{

    /**
     *  @class FormsStreams
     *  @alias module:src/server/com/silkplm/rpc/FormsStreams.FormsStreams
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param id {string} 
     * @param clazz {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ComputedLink.ComputedLink>>}
     */
     computeLinksForBusinessRecord(id, clazz) {
            return RpcClass.rpcCall('/rpc/forms-streams/compute-links-for-business-record', [id, clazz]);
    }
    /** 
     * @async
     * @param selection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @param clazz {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/StreamEditResult.StreamEditResult>}
     */
     deleteEntitiesFromStream(selection, clazz) {
            return RpcClass.rpcCall('/rpc/forms-streams/delete-entities-from-stream', [selection, clazz]);
    }
    /** 
     * @async
     * @param selection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @param clazz {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/StreamEditResult.StreamEditResult>}
     */
     editEntitiesFromStream(selection, fieldName, rawData, clazz) {
            return RpcClass.rpcCall('/rpc/forms-streams/edit-entities-from-stream', [selection, fieldName, rawData, clazz]);
    }
    /** 
     * @async
     * @param selection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string[]>}
     */
     findSelectedIdsStream(selection) {
            return RpcClass.rpcCall('/rpc/forms-streams/find-selected-ids-stream', [selection]);
    }
    /** 
     * @async
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/plm/StreamResult.StreamResult>}
     */
     followStream(streamingQuery) {
            return RpcClass.rpcCall('/rpc/forms-streams/follow-stream', [streamingQuery]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param selection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntitiesByStreamSelection(clazz, selection) {
            return RpcClass.rpcCall('/rpc/forms-streams/list-extended-entities-by-stream-selection', [clazz, selection]);
    }
    /** 
     * @async
     * @param selection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @param format {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SelectionMaterializeResponse.SelectionMaterializeResponse>}
     */
     materialize(selection, format) {
            return RpcClass.rpcCall('/rpc/forms-streams/materialize', [selection, format]);
    }
    /** 
     * @async
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/plm/StreamResult.StreamResult>}
     */
     startStream(streamingQuery) {
            return RpcClass.rpcCall('/rpc/forms-streams/start-stream', [streamingQuery]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.FormsStreams';
metadata.__type_short__ = 'FormsStreams';
FormsStreams.prototype.__metadata__ = metadata;

FormsStreams.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/FormsStreams */
export default FormsStreams

export { FormsStreams }
